import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'
import menuLink from '../../DaddyDaughterDate.pdf'
import menuImage from '../../assets/images/menuDaughter.png'

export default function DaddyDaughter(){
  return (
    <div className="pageStyles ddatePage">
      <Helmet>
        <title>Daddy Daughter Valentine's Dinner</title>
        <meta name="description" content="Show the most important girl in your life how special she is with a daddy-daughter Valentine's date to Villaggio Grille." />
      </Helmet>

      <div className="simpleBanner">
        <div className="bannerWrap med3Def">
          <h1>Daddy Daughter <br />Valentine's Dinner <span>💝</span></h1>
          <h4>February 1st <span className="d1">&middot;</span> <br />6pm <span className="d2">&middot;</span> $20 Per Child</h4>
          <p className="res">Reservations Recommended: <br/><span><PhoneLink /></span></p>
        </div>
      </div>

      <div className="page-content textCenter">
        <div className="sectionWrap insideNrw food-menus no-padding">
          <p className="instr">Click image below to view/download</p>
          <a href={menuLink} target="_blank" rel="noopener noreferrer" className="menu-item menuImg">
            <img src={menuImage} alt="Villaggio Lunch Menu, Orange Beach, AL restaurant" className="bshadow" />
          </a>
        </div>
      </div>
    </div>
  )
}
